import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@material-ui/core";

export default function ScrollDialog(props) {
  //   const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    props.setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    props.setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (props.content.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.content.open]);

  return (
    <div>
      <Dialog
        open={props.content.open}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          <Typography variant="h3">{props?.content?.heading}</Typography>
        </DialogTitle>
        <DialogContent dividers={scroll === "paper"}>
          <Typography variant="h5">{props?.content?.body}</Typography>
          <ol style={{ color: "#666666" }}>
            {props?.content?.points?.map((points, index) => {
              return (
                <li key={`index-${index}`}>
                  <Typography variant="h5">{points}</Typography>
                </li>
              );
            })}
          </ol>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
